import { EcoRoute, StaticRouteMappings } from "types";
import { EcoClient, EcoClientConfig, RouteConfig } from "@eco/client";


/**
 * Get the CSRF token
 * 
 */
export function getCsrf(): string | null  {

   let csrf = null ;
   const _csrfKey = 'eco-csrf' ;

    /** Dev mode : get CSRF from URL (as provided by login app) */
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i += 1) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === 'csrf' && sParameterName[1] && sParameterName[1].length) {
            csrf = decodeURIComponent(sParameterName[1]);
            localStorage.setItem(_csrfKey, csrf);
            return decodeURIComponent(sParameterName[1]);
        }
    }

    /** Try to get from local storage */
    csrf = localStorage.getItem(_csrfKey);

    if(csrf){
        return csrf ;
    }

    // TODO > get CSRF from page meta tag
    // throw new Error ("No csrf token found as page location parameter or from local storage. Need re login") ;

    return null;
}


/**
 * 
 * Creates a new intsance of EcoClient initialized from environnement variable
 * 
 */
export function createEcoClient() : EcoClient {

    const config = {
        baseUrl: process.env.REACT_APP_ECO_FACTORY_URL,
        appName: process.env.REACT_APP_ECO_APP_NAME,
    } as EcoClientConfig

    // initialize ecoClient
    return new EcoClient(config) ;

}



/**
 * 
 * Converts backend routes config  to react-router PartialRouteObject routes
 * 
 * @param routes 
 * 
 */
export const mapRouteConfigs = (routes : RouteConfig[], routeMappings: StaticRouteMappings) : EcoRoute[] => {
    
    return routes.map((config:RouteConfig) => {
        return {
            path: config.path,
            element : routeMappings[config.component],
            children : config.children && mapRouteConfigs(config.children, routeMappings),
            config
        }  as EcoRoute
    })
};
